import React from 'react';
import { Box } from '@mui/material';
import { CoordinationDetailsModel } from '../../../../api-service/clients';
import { DeepPartial, ServiceProviderAssignmentErrors } from './interfaces';
import { Cell } from '../../../../components/cell';
import { Row } from '../../../../components/row';
import { MaxLengthTextField } from '../../../../components/text-field';
import { Editor, IEditorRef } from '../../../../components/editor';

interface ICoordinationDetailsProps {
  coordinationDetails: DeepPartial<CoordinationDetailsModel>;
  isReadOnly: boolean;
  errors: Pick<ServiceProviderAssignmentErrors, never>;
  onRichTextChange: (section: 'backgroundInformation' | 'coordinationDetails' | 'assessmentInformation', fieldName: string, event: unknown, editor: unknown) => void;
  onAgreementsBetweenCitizenAndRelativesChange: (value: string) => void;
}

export function CoordinationDetails(props: ICoordinationDetailsProps) {
  const {
    coordinationDetails,
    isReadOnly,
    onRichTextChange,
    onAgreementsBetweenCitizenAndRelativesChange,
  } = props;

  const {
    descriptionOfOtherInterventionsRichText,
    agreementsBetweenCitizenAndRelatives,
  } = coordinationDetails || {};

  const descriptionOfOtherInterventionsEditorRef = React.useRef<IEditorRef>(null);

  return (
    <Box mt={1}>
      <Row>
        <Cell size="full">
          <Editor
            label="Beskrivelse af andre indsatser med eventuel behov for koordinering"
            value={descriptionOfOtherInterventionsRichText}
            initialValue={descriptionOfOtherInterventionsRichText}
            ref={descriptionOfOtherInterventionsEditorRef}
            onChange={(event, editor) => onRichTextChange('coordinationDetails', 'descriptionOfOtherInterventions', event, editor)}
            onBlur={(event, editor) => onRichTextChange('coordinationDetails', 'descriptionOfOtherInterventions', event, editor)}
            resizable
            selectorPrefix="assignment-description-other-interventions-"
            disabled={isReadOnly}
          />
        </Cell>
      </Row>
      <Box mt={1}>
        <Row>
          <Cell size="full">
            <MaxLengthTextField
              value={agreementsBetweenCitizenAndRelatives || ''}
              variant="outlined"
              maxLength={10000}
              multiline
              label="Eventuelle aftaler indgået mellem borger og pårørende med relevans for indsatsen"
              fullWidth
              rows={5}
              onChange={e => onAgreementsBetweenCitizenAndRelativesChange(e.currentTarget.value)}
              disabled={isReadOnly}
            />
          </Cell>
        </Row>
      </Box>
    </Box>
  );
}
